import type { FieldValues, UseFormSetError } from 'react-hook-form';
import { toast } from 'react-toastify';

import type { Optional } from '@types';

import i18n from '@features/i18n';
import { type ICommonError, POST_MESSAGE_EVENT_TYPE } from '@modules/types';
import { sendPostMessage } from '@utils/sendPostMessage';
import { showErrorToast } from '@utils/showErrorToast';

import { ROUTES } from '@constants';

type SetErrorForm = UseFormSetError<FieldValues>;

const { ACTIVATE_CODE, GIVE_BONUS_MANAGEMENT } = ROUTES;

export const catchCommonError = (
  error: unknown,
  setErrorForm?: Optional<SetErrorForm>
): void => {
  const isIframe = window.self !== window.top;

  if (
    isIframe &&
    window.location.pathname.includes(GIVE_BONUS_MANAGEMENT.ROOT)
  ) {
    sendPostMessage({
      data: error,
      type: POST_MESSAGE_EVENT_TYPE.ERROR_GIVE_BONUS_MODAL,
    });
  }

  if (isIframe && window.location.pathname.includes(ACTIVATE_CODE.ROOT)) {
    sendPostMessage({
      data: error,
      type: POST_MESSAGE_EVENT_TYPE.ERROR_ACTIVATE_CODE_MODAL,
    });
  }

  const { data } = (error as ICommonError) ?? {};
  const errors = data?.errors ?? [];

  if (data?.errors) {
    for (const error of errors) {
      setErrorForm?.(
        error?.source?.fieldPointer,
        { message: error?.title },
        { shouldFocus: true }
      );

      showErrorToast({
        errorData: error,
        target: 'catchCommonError',
      });
    }
  }

  if (!data?.errors?.length && data?.traceId) {
    const translationKey = i18n.t('common.toast.error.process', {
      error: i18n.t('common.toast.error.try.again'),
    });

    toast.error(
      `${data?.status ?? ''}: ${data?.title ?? ''}\n${
        data?.detail ?? translationKey
      }`,
      {
        toastId: translationKey,
        style: { whiteSpace: 'pre-wrap' },
      }
    );
  }
};
